import { gql } from "apollo-boost";
import Icons from "assets/Icons";
import EventDetailBar from 'components/platform/card/modules/EventDetailBar/EventDetailBar';
import { RolesSystem } from 'lib/enums/RolesSystem.enum';
import React, { Fragment } from 'react';
import { Subscription } from "react-apollo";
import { connect } from 'react-redux';
import CardBody from 'reactstrap/lib/CardBody';
import CardSubtitle from 'reactstrap/lib/CardSubtitle';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import UserDucks from 'stores/ducks/User.duck';


class EventCard extends React.Component<{ [label: string]: any }> {
	public state = {
		timeInfo: {
			startYear: 0,
			startMonth: 0,
			startDay: 0,
			startHour: 0,
			startMinutes: 0,
			startAMPM: 0,
			endYear: 0,
			endMonth: 0,
			endDay: 0,
			endHour: 0,
			endMinutes: 0,
			endAMPM: 0
		},
		loading: false,
		updateString: 0,
		updateString1: 0,
		totalPublic: 0,
		totalPrivate: 0,
		revenueTotal: '',
		name: '',
		payoutTime: '',
		onSale: true,
		isActive: '',
		location: '',
		currency: ''
	}

	constructor(props) {
		super(props)
		this.getNewInfo = this.getNewInfo.bind(this);
		this.getNewDetails = this.getNewDetails.bind(this);
	}

	public componentWillMount() {
		this.setState({
			timeInfo: this.props.timeObject, loading: false,
			revenueTotal: this.props.revenueTotal,
			totalPublic: this.props.totalPublic,
			totalPrivate: this.props.totalPrivate,
			name: this.props.name,
			payoutTime: this.props.payoutTime,
			onSale: this.props.onSale,
			isActive: this.props.isActive,
			location: this.props.location,
			currency: this.props.currency ? this.props.currency : 'USD'
		});
	}

	public getNewInfo(e: any) {

		fetchGraphQL(`
		{
			event {
			  get(eventId:"${this.props.id}") {
				revenueTotal,
				totalPrivate,
				totalPublic
			  }
			}
		  }
		`).then(res => {
			this.setState({
				revenueTotal: res.event.get.revenueTotal,
				totalPrivate: res.event.get.totalPrivate,
				totalPublic: res.event.get.totalPublic,
				updateString: e
			})
		})

		return undefined;
	}

	public getNewDetails(e: any) {
		fetchGraphQL(`
		{
			event {
			  get(eventId:"${this.props.id}") {
				name
				onSale
				payoutTime
				location
				isActive
				timeObject {
					startYear
					startMonth
					startDay
					startHour
					startMinutes
					startAMPM
				}
			  }
			}
		  }
		`).then(res => {
			this.setState({
				timeInfo: res.event.get.timeObject,
				name: res.event.get.name,
				onSale: res.event.get.onSale,
				payoutTime: res.event.get.payoutTime,
				location: res.event.get.location,
				isActive: res.event.get.isActive,
				updateString1: e
			});
		})

		return undefined;
	}

	public render() {


		// Subscription for ticket purchase
		const ticketPurchase = gql`
      			subscription {
        			ticketPurchase(eventIds:"${this.props.id}")
      			}
		`;

		// Subscripton for any change in information regarding the event that is displayed
		const eventInformationUpdate = gql`
			subscription {
				eventDetailsUpdated(eventId:"${this.props.id}")
			}
		`;

		if (this.state.loading) {
			return <div />
		} else {

			// NOTE NOTE - This.props.public is what comes from the public card view component

			let isHostOrAdmin = false;
			if (!this.props.public && (this.props.hosts.includes(this.props.user.id) || this.props.user.roles.includes(RolesSystem.ADMIN))) {
				isHostOrAdmin = true;
			}
			const { name, onSale, payoutTime, timeInfo, isActive, location } = this.state;

			return (
				<Fragment>
					<Subscription subscription={ticketPurchase}>
						{({ data }) => {
							if (data !== undefined && data !== null && data.ticketPurchase !== null) {
								if (data.ticketPurchase !== this.state.updateString) {
									return <img height={0} width={0} onLoad={this.getNewInfo(data.ticketPurchase)} style={{ display: 'none' }} />
								}
								return null;
							}
							return null;
						}}
					</Subscription>
					<Subscription subscription={eventInformationUpdate}>
						{({ data }) => {
							if (data !== undefined && data !== null && data.eventDetailsUpdated !== null) {
								if (data.eventDetailsUpdated !== this.state.updateString1) {
									return <img height={0} width={0} onLoad={this.getNewDetails(data.ticketPurchase)} style={{ display: 'none' }} />
								}
							}
							return null;
						}}
					</Subscription>
					<CardBody style={{ height: 'auto !important' }}>
						<CardSubtitle>
							{
								!isActive && payoutTime !== null && ((this.props.hosts && this.props.hosts.includes(this.props.user.id)) || (this.props.user.roles && this.props.user.roles.includes(RolesSystem.ADMIN))) ?
									<h5 className="cut-text" style={{ color: '#4d5adf' }}>&#x24;&nbsp;&#10003;&nbsp;{name + ' '}</h5>
									:
									(onSale !== false || !isActive ?
										<h5 className="sexyBlack cut-text">{name + ' '}</h5>
										: <h5 className="cut-text" style={{ color: '#8c8d94' }}><strong>||&nbsp;&nbsp;</strong>&nbsp;{name + ' '}</h5>
									)
							}
							<div style={{ height: 'auto', paddingBottom: '20px' }}>
								{
									!this.props.public ?
										<div style={{ width: '100%' }}>
											<EventDetailBar
												timezoneOffset={this.props.timezoneOffset}
												hostName={this.props.hostName || null}
												location={location}
												creationTimeZone={this.props.creationTimeZone}
												timeInfo={this.state.timeInfo}
												revenueTotal={this.state.revenueTotal}
												id={this.props.id}
												isHostOrAdmin={isHostOrAdmin}
												totalPrivate={this.state.totalPrivate}
												totalPublic={this.state.totalPublic}
												currency={this.state.currency}
											/>
											<p />
										</div> : <div>
											<div style={{ width: '100%' }}>
												<div style={{ float: 'left', width: '10%' }}>
													<img src={Icons.place} alt="Where is event happening?" />
												</div>

												<div className="cut-text" style={{ float: 'right', width: '90%', paddingTop: '5px', paddingLeft: '5px', color: '#878399' }}>
													{location}
												</div>
												<p />
											</div>
											<p><br /></p>
											<div style={{ width: '100%' }}>
												<div style={{ float: 'left', width: '10%' }}>
													<img
														src={Icons.materialCalendar}
														alt="When is Event happening?"
													/>
												</div>
												<div className="cut-text" style={{ float: 'right', width: '90%', paddingTop: '5px', paddingLeft: '5px', color: '#878399' }}>
													{
														String(timeInfo.startMonth) + '.' + String(timeInfo.startDay) + '.' + String(timeInfo.startYear) + ' ' +
														String(timeInfo.startHour) + ':' + (timeInfo.startMinutes / 10 < 1 ? String(timeInfo.startMinutes) + '0' : String(timeInfo.startMinutes))
													}
													{timeInfo.startAMPM ? 'PM' : 'AM'}
												</div>
											</div>
											<br />
										</div>
								}
							</div>
						</CardSubtitle>
					</CardBody>
				</Fragment>
			);
		}
	}

};

const mapStateToProps = state => ({
	user: UserDucks.getUser(state)
});

export default connect(mapStateToProps)(EventCard)


// WEBPACK FOOTER //
// ./src/components/platform/card/EventCard.tsx